import { useCallback } from "react";
import { useQuery } from "react-query";
import axios from "axios";
import { FlowVersionDetailRead } from "@hilos/types/private-schema";
import { API_ROUTES, buildAPIRoute } from "../router/router";

function useFlowVersion(id: string | null = null) {

  const fetchFlowVersion = useCallback(async () => {
    if (!id) {
      return null;
    }

    const { data } = await axios.get<FlowVersionDetailRead>(
      buildAPIRoute(API_ROUTES.FLOW_VERSION_DETAIL, {
        ":id": id,
      })
    );
    return data;
  }, [id]);

  const { data, refetch } = useQuery(
    ["flow_version_detail", id],
    fetchFlowVersion
  );

  const setFlowVersionAsCurrent = useCallback(async () => {
    await axios.post(
      buildAPIRoute(API_ROUTES.FLOW_VERSION_SET_CURRENT, {
        ":id": id,
      })
    );
  }, [id]);

  const createDraftFromVersion = useCallback(async () => {
    await axios.post(
      buildAPIRoute(API_ROUTES.FLOW_VERSION_CREATE_DRAFT_FROM_VERSION, {
        ":id": id,
      })
    );
  }, [id]);

  return {
    data,
    refetch,
    setFlowVersionAsCurrent,
    createDraftFromVersion,
  };
}

export default useFlowVersion;
